<keycloak-auth-manager-kam-role-selection  style="width: 100%;"
    [initialRolesSelected]="initialRolesSelected"
    (roleSelection)="rolesSubscriptionUpdate($event)">    
</keycloak-auth-manager-kam-role-selection>
<div class="acctions">
    <button mat-button matStepperPrevious>{{'KAM-MANAGE-GROUPS.STEP3.BACK' | translate}}</button>
    <button mat-button matStepperNext (click)="step3End()">{{'KAM-MANAGE-GROUPS.STEP3.NEXT' | translate}}</button>
</div>